import {
  JOB_CONFIG_TEMPLATES_URL,
  JOB_CONFIG_TEMPLATE_URL,
  SEARCH_JOB_CONFIG_TEMPLATES_URL
} from 'app/utils/Constants';

import {
  post,
  put,
  patch
} from 'app/services/ApiService';

export const getJobConfigTemplates = async params => {
  return await post(SEARCH_JOB_CONFIG_TEMPLATES_URL(), params);
}

export const createJobConfigTemplate = async params => {
  return await post(JOB_CONFIG_TEMPLATES_URL(), params);
}

export const updateJobConfigTemplate = async (id, params) => {
  return await put(JOB_CONFIG_TEMPLATE_URL(id), params);
}

export const destroyJobConfigTemplates = async ids => {
  let params = { ids };
  return await patch(JOB_CONFIG_TEMPLATES_URL(), params);
}
